export const random = (min: number, max: number) => {
  return min + Math.random() * (max - min);
};
export const randomInt = (min: number, max: number) => {
  return Math.round(random(min, max));
};
export const randomChoice = <T>(choices: readonly T[]): T => {
  return choices[randomInt(0, choices.length - 1)];
};
